export const Gtag = {
	methods: {
        sendGaEvent(action, category, label) {
            if (process.env.MIX_APP_ENV != 'production') {
                return
            }

        	if (gtag) {
	            gtag('event', action, {
	                'event_category': category,
	                'event_label': label
	            });
	        }
        },
        sendReservationGaEvent({reservation}) {
            if (!window.isMobile()) {
                if (reservation.is_trial_lesson) {
                    this.sendGaEvent(
                        'Prenotazioneconclusa', 
                        'Corsi',
                        '#prenota-prova-step1'
                    )
                } else {
                    this.sendGaEvent(
                        'Prenotazioneconclusa',
                        'Corsi',
                        '#prenota-ingresso-step1'
                    )                    
                }
            } else {
                if (reservation.is_trial_lesson) {
                    this.sendGaEvent(
                        'Prenotazioneconclusa',
                        'Corsi',
                        '#prenota-prova-step1-mobile'
                    )
                } else {
                    this.sendGaEvent(
                        'Prenotazioneconclusa',
                        'Corsi',
                        '#prenota-ingresso-step1-mobile'
                    )                    
                }                    
            }            	
        },
        sendReservationFormGaEvent(reservation) {
            if (window.isMobile()) {
                if (this.form.is_trial_lesson) {
                    this.sendGaEvent(
                        'Prenotazionestart',
                        'Corsi',
                        '#prenota-prova-sticky-step0'
                    )
                } else {
                    this.sendGaEvent(
                        'Prenotazionestart',
                        'Corsi',
                        '#prenota-ingresso-sticky-step0'
                    )
                }
            }                 
        },
        sendCourseAddToCartGaEvent() {
            if (window.isMobile()) {
                this.sendGaEvent(
                    'Acquista',
                    'Corsi',
                    '#aggiungi-carrello-sticky'
                )
            } else {
                this.sendGaEvent(
                    'Acquista',
                    'Corsi',
                    '#aggiungi-carrello-spalla'
                )
            }            
        }			
	}
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/ga.js